import React from 'react';
import Productos from './Productos';

const Tienda = () => {
    return (
        <div>
            <h1>¿Que te ofrecemos?</h1>
            <Productos />
        </div>
    );
}
 
export default Tienda;